import { TextButton } from '@twistopayments/design-system/components/atoms/button'

import type { SectionsSimpleTextComponent } from '@twisto/api-cms'
import { useBreakpoint } from '@twisto/hooks'

import { useHighlightedText } from 'homepage/libs/hooks'

import * as styles from './simple-text.styles'

export function SimpleText(props: SectionsSimpleTextComponent) {
  const { title, highlight, description, cta } = props

  const isMobile = useBreakpoint('smDown')

  const {
    before: titleBefore,
    highlight: titleHighlight,
    after: titleAfter,
  } = useHighlightedText(title, highlight)

  return (
    <div css={styles.wrap}>
      <div css={styles.title}>
        {titleBefore}
        <span>{titleHighlight}</span>
        {titleAfter}
      </div>

      <div css={styles.desc}>{description}</div>

      {cta?.link && cta.text && (
        <TextButton fullWidth={isMobile} href={cta.link}>
          {cta.text}
        </TextButton>
      )}
    </div>
  )
}
